import React from 'react';
import c from 'classnames';
import NoAI from '@wix/da-ds/pkg/Indicators/NoAI';
import SophisticatedTooltipLink from '@wix/da-ds/pkg/tooltips/SophisticatedTooltipLink';
import SophisticatedTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SophisticatedTooltip';
import { useTranslation } from 'react-i18next';
import s from './NoAIWithTooltip.scss';
export const NoAIWithTooltip = ({ className })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(SophisticatedTooltip, {
        className: c(s['root'], className),
        size: "medium",
        "aria-label": t('noAIWithTooltip.noai'),
        description: t('noAIWithTooltip.tooltip'),
        hasCloseButton: false,
        postfix: /*#__PURE__*/ React.createElement(SophisticatedTooltipLink, {
            href: t('noAIWithTooltip.readMore.url')
        }, t('noAIWithTooltip.readMore'))
    }, /*#__PURE__*/ React.createElement(NoAI, {
        className: s['icon']
    }), " ", t('noAIWithTooltip.noai'));
};
NoAIWithTooltip.displayName = 'NoAIWithTooltip';
export default NoAIWithTooltip;
